var React = require('react');

function Ads (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M36 12H4V8H36V12ZM32 0H8V4H32V0ZM40 20V36C40 38.2 38.2 40 36 40H4C1.8 40 0 38.2 0 36V20C0 17.8 1.8 16 4 16H36C38.2 16 40 17.8 40 20ZM28 28L16 21.46V34.52L28 28Z","fill":"currentColor"}));
}

Ads.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Ads;

Ads.default = Ads;
